<template>
    <div>

            <div class="overflowRightNav">
            <Row style="padding-bottom: 30px">
                <Col span="4" align="center">
                    <DatePicker
                            split-panels
                            type="daterange"
                            :options="options"
                            placeholder="选择日期"
                            @on-change="handleOk"
                            :value="valuedate"
                            style="width: 80%">
                    </DatePicker>
                </Col>
            </Row>
            <Row class="statis_title">
                <Col span="3"  align="center">
                    <h4>总收入</h4>
                    <p>{{comeMoney}}</p>
                </Col>
                <Col span="3" align="center">
                    <h4>总支出</h4>
                    <p>{{sumPutMoney}}</p>
                </Col>
                <Col span="3" align="center">
                    <h4>结余</h4>
                    <p>{{comeMoney-sumPutMoney}}</p>
                </Col>
            </Row>
            <ul class="pay_list">
                <li>
                    <img src="../../assets/img/tools/bitcoin-cash.png" >
                    <h4>现金</h4>
                    <Row>
                        <Col span="12">收入：{{m.hykcomemoney}} </Col>
                        <Col span="12" align="right"><span>结余</span> </Col>
                    </Row>
                    <Row>
                        <Col span="12">支出：{{m.hykputmoney}} </Col>
                        <Col span="12" align="right"><span style="color: #ff795e">{{m.hykcomemoney-m.hykputmoney}}</span> </Col>
                    </Row>
                </li>
                <li>
                    <img src="../../assets/img/tools/address.png" >
                    <h4>微信</h4>
                    <Row>
                        <Col span="12">收入：{{m.hykcomemoney}} </Col>
                        <Col span="12" align="right"><span>结余</span> </Col>
                    </Row>
                    <Row>
                        <Col span="12">支出：{{m.hykputmoney}} </Col>
                        <Col span="12" align="right"><span style="color: #ff795e">{{m.hykcomemoney-m.hykputmoney}}</span> </Col>
                    </Row>
                </li>
                <li>
                    <img src="../../assets/img/tools/stellar.png" >
                    <h4>支付宝</h4>
                    <Row>
                        <Col span="12">收入：{{m.hykcomemoney}} </Col>
                        <Col span="12" align="right"><span>结余</span> </Col>
                    </Row>
                    <Row>
                        <Col span="12">支出：{{m.hykputmoney}} </Col>
                        <Col span="12" align="right"><span style="color: #ff795e">{{m.hykcomemoney-m.hykputmoney}}</span> </Col>
                    </Row>
                </li>
                <li>
                    <img src="../../assets/img/tools/cryptocurrencies-going-up.png" >
                    <h4>银行卡</h4>
                    <Row>
                        <Col span="12">收入：{{m.hykcomemoney}} </Col>
                        <Col span="12" align="right"><span>结余</span> </Col>
                    </Row>
                    <Row>
                        <Col span="12">支出：{{m.hykputmoney}} </Col>
                        <Col span="12" align="right"><span style="color: #ff795e">{{m.hykcomemoney-m.hykputmoney}}</span> </Col>
                    </Row>
                </li>
                <li>
                    <img src="../../assets/img/tools/withdraw.png" >
                    <h4>会员卡</h4>
                    <Row>
                        <Col span="12">收入：{{m.hykcomemoney}} </Col>
                        <Col span="12" align="right"><span>结余</span> </Col>
                    </Row>
                    <Row>
                        <Col span="12">支出：{{m.hykputmoney}} </Col>
                        <Col span="12" align="right"><span style="color: #ff795e">{{m.hykcomemoney-m.hykputmoney}}</span> </Col>
                    </Row>
                </li>
                <li>
                    <img src="../../assets/img/tools/buy-cryptocurrencies.png" >
                    <h4>其他</h4>
                    <Row>
                        <Col span="12">收入：{{m.hykcomemoney}} </Col>
                        <Col span="12" align="right"><span>结余</span> </Col>
                    </Row>
                    <Row>
                        <Col span="12">支出：{{m.hykputmoney}} </Col>
                        <Col span="12" align="right"><span style="color: #ff795e">{{m.hykcomemoney-m.hykputmoney}}</span> </Col>
                    </Row>
                </li>
            </ul>
            </div>

    </div>
</template>
<script>
    export default {
        components: {},
        data() {
            return {
                cid: "",
                comeMoney:'',//总收入
                sumPutMoney:'',//总支出
                m:{},
                nowTime:"",
                valuedate: [],
                data:'',
                options: {
                    shortcuts: [
                        {
                            text: '过去一周',
                            value () {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                                return [start, end];
                            }
                        },
                        {
                            text: '过去一月',
                            value () {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                                return [start, end];
                            }
                        },
                        {
                            text: '过去三月',
                            value () {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                                return [start, end];
                            }
                        }
                    ],
                }
            }
        },
        mounted: function () {
            //DOM更新完后再请求数据
            this.$nextTick(function () {


            });
        },
        created: function () {
            //DOM更新完之前请求数据
            let data= JSON.parse(localStorage.getItem('adminUser'))
            this.cid=data.cid
            var date = new Date()
            this.nowTime = date.getFullYear()+'-'+(date.getMonth()+1)+'-'+date.getDate()
            this.valuedate[0] = this.nowTime
            this.valuedate[1] = this.nowTime
             this.getTodaySumList(this.nowTime,this.nowTime)
        },
        methods: {
            getTodaySumList(startTime,endTime){
                let data = {
                    cid: this.cid,
                    beantime:startTime,
                    etime: endTime
                };

                this.$Api.getTodaySumList(data).then(res => {
                    if (res.code == 200) {
                        this.comeMoney = res.data.comeMoney
                        this.sumPutMoney = res.data.sumPutMoney
                        this.m = res.data.m
                    } else {
                        this.$Message.warning(res.msg);
                    }
                })
            },
            handleOk(data){
                this.getTodaySumList(data[0],data[1])
            }
        }
    }
</script>


<style lang="scss" scoped>
    .server-title {
        display: inline-block;
        text-align: center;
        width: 88%
    }
    .statis_title{
        p{
            color: #ff795e;
            padding-top: 10px;
        }
    }
    .pay_list{
        li{
            width: 327px;
            height: 95px;
            background-color: #ffffff;
            border-radius: 5px;
            box-shadow: 0px 3px 10px 0px rgba(24, 54, 129, 0.14);
            margin:10px auto;
            position: relative;
            padding: 16px 16px 16px 90px;
            float: left;
            margin: 20px;
            img{
                position: absolute;
                top: 50%;
                margin-top: -30px;
                left: 15px;
            }
        }
    }

</style>